module.exports = __webpack_public_path__ + "img/20191231154137966.f26de9bd.jpg";